<template>
  <div
    class="h-screen flex w-full vx-row no-gutter items-center justify-center"
    id="page-selectassets"
  >
    <div class="vx-col sm:w-full md:w-3/4 lg:w-3/4 xl:w-3/5 sm:m-0 m-4">
      <template v-if="mode == 'select_s'">
        <vx-card title="Select one of your assets">
          <div v-if="user.count_s < 1">
            <div>You do not have any asset. Plase create one.</div>
          </div>
          <div v-else>
            <div class="vx-row w-full">
              <div
                v-for="(list, i) of s_list"
                :key="i"
                class="vx-col sm:w-full md:w-1/2 lg:w-1/2 xl:w-1/2 sm:m-0 m-4"
              >
                <div class="card my-2">
                  <div class="card-header">
                    <h4 class="card-title">{{ list.name }}</h4>
                  </div>
                  <div class="card-content" aria-expanded="true">
                    <div class="card-body">
                      <div class="mb-4">
                        <div
                          class="seller-logo"
                          v-bind:style="{
                            'background-image': 'url(' + list.logo + ')'
                          }"
                        ></div>
                      </div>
                    </div>
                  </div>
                  <div class="card-footer text-right">
                    <vs-button
                      @click="selectS(list)"
                      color="primary"
                      size="small"
                      type="filled"
                      >Select</vs-button
                    >
                  </div>
                </div>
              </div>
            </div>
          </div>
        </vx-card>
      </template>
      <template v-if="mode == 'select_e'">
        <vx-card title="Select one of your assets">
          <vs-breadcrumb class="mb-8">
            <li>
              <a href="#" @click.prevent="changeModeToS()" title="Sellers"
                >Sellers</a
              >
              <span class="vs-breadcrum--separator">/</span>
            </li>
            <li>
              <span href="#" title="Select an Event">Select an Event</span>
            </li>
          </vs-breadcrumb>

          <vs-tabs>
            <vs-tab label="All Events">
              <div class="con-tab-ejemplo">
                <b-table
                  ref="table"
                  style="height: 600px;"
                  striped
                  hover
                  fixed
                  responsive
                  show-empty
                  sort-icon-left
                  :selectable="false"
                  :items="eventDataProvider"
                  :select-mode="`multi`"
                  :fields="columns"
                  :current-page="currentPage"
                  :per-page="perPage"
                >
                  <template v-slot:table-busy>
                    <div
                      class="text-center text-danger my-2"
                      style="height:600px;"
                    >
                      <b-spinner class="align-middle"></b-spinner>
                      <div class="mt-3">
                        <strong>Loading...</strong>
                      </div>
                    </div>
                  </template>

                  <template v-slot:cell(date)="data">
                    <div style="width:150px;">
                      <strong>
                        {{ data.item.date }}
                        <br />
                        {{ data.item.time }}
                      </strong>
                    </div>
                  </template>

                  <template v-slot:cell(pro_name)="data">
                    <h6>{{ data.item.pro_name }}</h6>
                    <div class="text-grey">at {{ data.item.venue }}</div>
                  </template>

                  <template v-slot:cell(action)="data">
                    <vs-button
                      @click="selectE(data.item)"
                      color="primary"
                      type="flat"
                      >Select</vs-button
                    >
                  </template>
                </b-table>
                <div class="mt-3 text-right">
                  <vs-pagination
                    :total="Math.ceil(totalRows / 30)"
                    v-model="currentPage"
                    prev-icon="arrow_back"
                    next-icon="arrow_forward"
                  ></vs-pagination>
                </div>
              </div>
            </vs-tab>
          </vs-tabs>
        </vx-card>
      </template>
    </div>
  </div>
</template>
<script>
import Service from "@/services";

import { mapState } from "vuex";
export default {
  data() {
    return {
      mode: "select_s",
      currentPage: 1,
      perPage: 30,
      totalRows: 0,
      from: 1,
      to: 0,
      s_list: [],
      e_upcoming_list: [],
      columns: [
        { label: "Start Time", key: "date", sortable: false },
        { label: "Name", key: "pro_name", sortable: false },
        { label: "", key: "action", sortable: false }
      ]
    };
  },
  computed: {
    ...mapState({
      user: state => {
        return state.Auth.user;
      }
    })
  },
  created() {
    if (this.$route.query.s) {
      this.mode = "select_e";
      setTimeout(() => {
        this.$refs.table.refresh();
      }, 800);
    } else {
      this.loadSellers();
    }
  },
  methods: {
    selectS(seller) {
      this.$vs.loading();

      Service.Auth.updateProfile({ s: seller.s }).then(res => {
        if (res.success) {
          this.$store.dispatch("Utility/setMerchant", res.data.default.s);
          this.$router.replace({ query: { s: res.data.default.s } });
          this.mode = "select_e";
          this.e_upcoming_list = [];
          setTimeout(() => {
            this.$refs.table.refresh();
          }, 1000);
        }
        this.$vs.loading.close();
      });
    },
    selectE(event) {
      this.$vs.loading();
      Service.Auth.updateProfile({
        s: event.merchant.s,
        e: event.e
      })
        .then(res => {
          if (res.success) {
            this.$store.dispatch("Utility/setMerchant", res.data.default.s);
            this.$store.dispatch("Utility/setEvent", res.data.default.e);
            this.$router.replace({
              name: "dash",
              query: { s: res.data.default.s, e: res.data.default.e }
            });
          }
          this.$vs.loading.close();
        })
        .catch(err => {
          this.$vs.notify({
            title: "Oops!",
            text: "ERROR : " + err.error,
            color: "danger"
          });
          this.$vs.loading.close();
        });
    },
    eventDataProvider(ctx, callback) {
      let data = {
        s: this.$route.query.s,
        page: this.currentPage
      };
      let params = Object.keys(data)
        .map(key => key + "=" + data[key])
        .join("&");

      this.$vs.loading();

      this.upcoming = { total: 0, from: 0, to: this.perPage, page: 1 };
      this.previous = { total: 0, from: 0, to: this.perPage, page: 1 };
      Service.Event.my(params)
        .then(res => {
          this.totalRows = res.data.total;
          this.from = res.data.from;
          this.to = res.data.to;
          this.e_upcoming_list = res.data.rows;

          callback(this.e_upcoming_list);

          this.$vs.loading.close();
        })
        .catch(error => {
          callback([]);
        });
    },
    loadSellers() {
      Service.Auth.getMySellers().then(res => {
        this.s_list = res.data;
      });
    },
    changeModeToS() {
      this.mode = "select_s";
      this.loadSellers();
    }
  }
};
</script>
<style lang="scss" scoped>
.seller-logo {
  width: 100%;
  height: 90px;
  background-position: center;
  background-size: cover;
  padding: 30px;
}
.logo {
  width: 100px;
}
</style>
